<template>
  <div class="portrait-index-wrapper">
    <w-navbar :icon="'iconchevron-left'"
              nav_title="超级简历证件照"
              @mobileLeftBtn="leftBtnClick"
              v-if="!isRN"
              :isShowLeftIcon="true" />
    <div class="portrait-index-content">
      <img :src="item" alt="" v-for="(item, index) in imgSrcList" :key="'img&' + index">

      <div class="btn-box">
        <div class="btn" @click="debounce(() => { upImgTriggerFunc() }, 300)">拍摄或上传</div>
        <input class="up-img-input" ref="upImgInput" type="file" accept="image/*" @change="upImgChangeFunc()">
      </div>
    </div>
    <!-- loading 动画 -->
    <w-loading :show-text="true" v-show="loadingVsible"/>
  </div>
</template>

<script>
import WNavbar from '@/components/global/w-navbar'
import WLoading from "@/components/global/w-loading"
import { componentsMixin } from '@/assets/js/mixin/components'
import { updateJWT } from '@/assets/js/utils'
import moment from "moment/moment";
export default {
  data () {
    return {
      imgFile: null, // 照片 base64
      imgType: null, // 照片类型
      photoId: null, // 唯一 id

      loadingVsible: false, // loading visible

      imgSrcList: [
        'https://files.wondercv.com/M/wondercv/cvs/photo/tip1.png',
        'https://files.wondercv.com/M/wondercv/cvs/photo/tip2.png',
        'https://files.wondercv.com/M/wondercv/cvs/photo/tip3.png',
        'https://files.wondercv.com/M/wondercv/cvs/photo/tip4.png',
        'https://files.wondercv.com/M/wondercv/cvs/photo/tip5.png',
      ],
      isRN: false,
      isPc: false,
      cvToken: '',
    }
  },
  mixins: [ componentsMixin ],
  components: {
    WNavbar,
    WLoading
  },
  async created () {
    // 获取 photoId
    const { photoId, jwt, isPc, cvToken } = this.$route.query
    this.photoId = photoId
    this.isPc = !!isPc
    this.cvToken = cvToken
    if (jwt) {
      await updateJWT({
        jwt: jwt,
        jwt_timestamp: moment().valueOf(),
        cookieEndTime: moment().add(14, 'd').valueOf()
      })
    }

    this.isRN = !!window.ReactNativeWebView
    if(this.isRN){
      this.postMessage('pageMounted', 'pageMounted')
      this.initMessage()
    }
  },
  methods: {
    // initMessage
    initMessage() {
      window.receiveFile = msg => {
        // 拿到 base64 照片
        this.imgFile = msg
        // 照片质量检测
        this.photoCheckFunc(this.imgFile)
      }
    },
    // postMessage
    postMessage(type, data) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type,
        data,
      }))
    },
    // 触发手机上传照片
    upImgTriggerFunc () {
      if (this.isRN) {
        this.postMessage('chooseFile', 'chooseFile')
      } else {
        this.$refs.upImgInput.click()
      }
    },
    // 监听照片
    upImgChangeFunc () {
      let file = this.$refs.upImgInput.files
      // 重置照片文件
      this.imgFile = null
      // 获取照片类型
      this.imgType = file[0].type.split('/')[1]
      // 处理新上传的照片文件 base64
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = e => {
        // 拿到 base64 照片
        this.imgFile = e.currentTarget.result
        // 照片质量检测
        this.photoCheckFunc(this.imgFile)
      }
    },
    leftBtnClick() {
      if (this.cvToken) {
        this.$router.replace(`/cvs/${this.cvToken}/editor`)
      } else {
        this.$router.replace('/cvs')
      }
    },
    // 照片质量检测
    async photoCheckFunc (val) {
      this.loadingVsible = true
      try {
        let params = {
          file: val.split('base64,')[1]
        }
        let res = await this.$api.transferStation.photoCheck(params)
        if (res.code === 1000) {
          this.$router.push({
            name: 'upload-portrait-check',
            params: {
              imgFile: this.imgFile,
              imgType: this.imgType,
              photoId: this.photoId,
              info: res.data,
              isPc: this.isPc,
              cvToken: this.$route.query.cvToken,
            }
          })
        } else if (res.code === 201203) {
          this.showToast('请求超时，请重新上传')
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVsible = false
      } catch (error) {
        console.log(error)
        this.loadingVsible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .portrait-index-wrapper {
    width: 100%;

    .portrait-index-content {
      position: relative;
      padding: 55px 20px 123px;
      background: #F9F9F9;

      >img {
        width: 100%;
        margin-bottom: 12px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      .btn-box {
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
        background: #ffffff;
        padding: 10px 20px 42px;
        display: flex;
        align-items: center;

        .btn {
          width: 100%;
          height: 46px;
          line-height: 46px;
          font-size: 14px;
          font-weight: 500;
          border-radius: 4px;
          text-align: center;
          color: #ffffff;
          background: #ff6644;
          letter-spacing: 1px;
        }

        .up-img-input {
          width: 100%;
          position: absolute;
          z-index: -1;
          left: 0;
          top: 10px;
          opacity: 0;
        }
      }
    }
  }
</style>
